module.exports = __webpack_public_path__ + "static/reason_300.5d19cfa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reason_300.png
// module id = ./src/images/reason_300.png
// module chunks = 4